import { useEffect } from 'react';

import { useSelector } from 'react-redux';

export const useDocumentTitle = () => {
    const state = useSelector((state:any) => state.env.env)
    console.log('state',state)
    useEffect(()=> {
        if(state.length) {
            document.title = `Toyota - ${state}`
        }
        else{
            document.title = 'Toyota'
        }
    },[state])
}